import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import FlexView from "react-flexview";

import Label from "../Label";

const propTypes = {
  certLink: PropTypes.string.isRequired,
  sealLink: PropTypes.string.isRequired,
  setCopiedNotice: PropTypes.func.isRequired,
  copiedNotice: PropTypes.bool.isRequired
};
const defaultProps = {};

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background-color: transparent;
  padding: 0px 25px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 4px;
  color: #ffffff;
  > h3 {
    display: none;
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.85);
    > h3 {
      display: block;
    }
  }
`;

const CopiedOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background-color: rgba(50, 103, 78, 0.75);
  padding: 0px 25px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 4px;
  color: #ffffff;
`;

function SignatureInput({ sealLink, copiedNotice, clippy }) {
  return (
    <FlexView width="100%" hAlignContent="left" column>
      <Label
        leadText="Step 3:"
        labelText="Click on the signature below to copy your PrivySeal"
      />
      <span style={{ fontSize: "12px" }}>
        <a
          href="https://support.privyseal.com/hc/en-us/articles/360007001171-Installing-your-Privyseal-in-Apple-Mail"
          target="_blank"
        >
          Follow these instructions
        </a>{" "}
        to create a signature in Apple Mail
      </span>
      <FlexView
        marginTop="15px"
        width="100%"
        height="300px"
        style={{
          position: "relative",
          borderRadius: "4px"
        }}
        hAlignContent="center"
        vAlignContent="center"
        onClick={clippy}
      >
        {!copiedNotice ? (
          <Overlay>
            <h3>Click this block or hold down ⌘ + c to copy your PrivySeal</h3>
          </Overlay>
        ) : (
          <CopiedOverlay>
            <h3>PrivySeal copied to your clipboard</h3>
          </CopiedOverlay>
        )}
        <FlexView id="seal-rtf">
        <img src={sealLink} alt="My PrivySeal" style={{width: "100%"}}/>
        </FlexView>
      </FlexView>
    </FlexView>
  );
}

SignatureInput.propTypes = propTypes;
SignatureInput.defaultProps = defaultProps;

export default SignatureInput;



// WEBPACK FOOTER //
// ./src/components/SignatureInput/index.js